<template>
  <div class="progress-circle-list-item">
    <SvgProgressCircle
      :width="66"
      :stroke-opacity="1"
      :stroke-width="6"
      stroke-color="#0585d3 "
      :progress="_progressPercent"
    >
      <div class="progress">
        <p>{{ _progressPercent }}</p>
        <p class="small">
          %
        </p>
      </div>
    </SvgProgressCircle>
    <div class="item-content">
      <p
        class="item-title"
        @click="$_taskPopupOpen()"
      >
        {{ title }}
      </p>
      <div class="content-list">
        <WsTextChip001
          :text-label="`${num} / ${totalNum}`"
          leading-icon="icon-check-circle-filled"
          thin
          gray
          icon-lg
          font-size-md
        />
        <WsTextChip001
          :text-label="$_dateFormat(date)"
          leading-icon="icon-duedate"
          :red="$_getExpired(date)"
          gray
          thin
          icon-lg
          font-size-md
        />
      </div>
    </div>
  </div>
</template>
<script>
import SvgProgressCircle from "@wasateam/vue-svg-progress-circle";
export default {
  name: "ProgressCircleListItem",
  components: {
    SvgProgressCircle,
  },
  props: {
    date: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    totalNum: {
      type: Number,
      default: 0,
    },
    num: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    _progressPercent() {
      if (!this.totalNum || !this.num) return 0;
      let progress = this.num / this.totalNum;
      let progressToFix = progress * 100;
      return parseFloat(progressToFix.toFixed(1));
    },
  },
  methods: {
    $_getExpired(time) {
      if (!time) return;
      let today = this.$moment();
      let expirdDate = this.$moment(time);
      if (today.diff(expirdDate, "days", true) > 0) {
        return true;
      } else {
        return false;
      }
    },
    $_dateFormat(date) {
      if (!date) return;
      return this.$moment(date).format("YYYY-MM-DD");
    },
    $_taskPopupOpen() {
      this.$emit("task-popup-open");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/progress-circle-list-item";
</style>